import { MdCreditCard, MdPersonAdd} from "react-icons/md";
import { createCRUDConstants } from "../../../utils/redux.utils";
export const quicklinks = [
    {
      path: "/disbursement/add",
      title: "Create Disbursement",
      icon: MdCreditCard,
      color:'info'
    },
    {
      path: "/users/add",
      title: "Create User",
      icon: MdPersonAdd,
      color:'info'
    }
  ];


  export const nameSpace = "DASHBOARD";
export const dashBoardConstants = createCRUDConstants(nameSpace, [
"GET",
"ACTIVE",
"DATA"
]);